package com.picme.sdk2

object SafeIds {
    fun encode(id: String): String = id.replace(".", "_DOT_")
    fun decode(urlSafeId: String): String = urlSafeId.replace("_DOT_", ".")
}

fun String.toSafeEncoded(): String = SafeIds.encode(this)
fun String.toSafeDecoded(): String = SafeIds.decode(this)
